/**
 * Created by Administrador on 16/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('classificationCtrl', classificationCtrl)
        .controller('newEditClassificationCtrl', newEditClassificationCtrl)
        .controller('deleteClassificationCtrl', deleteClassificationCtrl);

    classificationCtrl.$inject = ['linkService', 'tabs','classifications'];

    newEditClassificationCtrl.$inject = ['tabs', 'classificationService', 'linkService', 'classification','action'];

    deleteClassificationCtrl.$inject = ['classification', 'classificationService', '$uibModalInstance','linkService'];

    function classificationCtrl(linkService, tabs, classifications){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = classifications.data.page;
        vm.classifications = (classifications.data._embedded) ? classifications.data._embedded.classifications : [];
        vm.linkService = linkService;
    }

    function newEditClassificationCtrl(tabs, classificationService, linkService, classification, action){
        var vm = this;
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.classification = {};

        if(action == 'edit'){
            vm.classification.lang = classification.data.lang;
            vm.classification.priority = classification.data.priority;
            vm.classification.classificationId = vm.linkService.getLinkId(classification.data._links.self.href);
        }

        vm.saveClassification = function(isValid, classification){
            if (isValid) {
                if(action == "new"){
                    classificationService.saveClassification(classification);
                }else{
                    classificationService.updateClassification(vm.classification.classificationId, vm.classification)
                }
            }
        }
    }

    function deleteClassificationCtrl(classification, classificationService, $uibModalInstance,linkService){
        var vm = this;
        vm.classification = classification.data;

        vm.deleteClassification = function(){
            classificationService.deleteClassification(linkService.getLinkId(classification.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
